module.exports = __webpack_public_path__ + "media/images/pic/teachers/marta-klimiuk-nikkarinen-acf1f2652ea713c377c004e00b8ce9c8.webp";